import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class AttachmentApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/attachments`;
    }

    uploadTemporary(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.httpClient.post<any>(`${this.url}/temporary`, formData);
    }

    uploadMultipleTemporary(files: File[]): Observable<any> {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });
        return this.httpClient.post<any>(`${this.url}/temporary/multiple`, formData);
    }

    deleteTemporary(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/temporary/${id}`);
    }
}

